<template>
  <LayoutContent>
    <h2 class="text-h5 secondary--text font-weight-bold text-capitalize">{{ $t('label.ourStores') }}</h2>
    <div v-if="loading" class="text-center" style="margin-top: 20%">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <section v-else>
      <div v-if="brandList.length > 0" class="mt-5 mb-8 d-flex flex-row align-start">
        <p class="mb-0 mr-3 secondary--text font-weight-bold">{{ $t('label.brand') }}:</p>
        <div class="d-flex flex-row align-center flex-wrap">
          <v-chip
            :class="['mr-2 mr-md-3 mb-2 font-weight-bold elevation-2', Number(brandId) === brand.id ? 'white--text primary lighten-1' : 'white primary--text text--darken-1']"
            v-for="(brand, index) in brandList"
            :key="index"
            @click="
              $router.replace({
                name: $constants.ROUTE_NAME.SALON_INFO_LIST,
                query: { brand: brand.id }
              })
            "
          >
            {{ brand.name }}
          </v-chip>
        </div>
      </div>
      <div class="salons-list mb-4" :class="!$vuetify.breakpoint.mdAndUp && 'items-center'">
        <SalonCard v-for="salon in storeList" :brand="brandId" :salon="salon" :currentLocation="currentLocation" :key="salon.branchName" />
      </div>
    </section>
  </LayoutContent>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import LayoutContent from '@/views/layouts/LayoutContent'
import SalonCard from '@/components/salons/SalonCard.vue'
import { uiHelper } from '@/utils'

export default {
  name: 'SalonInfoListing',
  components: {
    LayoutContent,
    SalonCard
  },
  data() {
    return {
      loading: false,
      currentLocation: { latitude: '', longitude: '' },
      cardBodyHeight: 0,
      brandId: null
    }
  },
  watch: {
    $route() {
      this.fetchStores()
    }
  },
  computed: {
    ...mapState('common', ['storeList', 'brandList'])
  },
  async mounted() {
    uiHelper.getLocation(this.currentLocation)
    if (this.$route.query.brand) this.brandId = this.$route.query.brand
    this.getStoreList({ brand_id: this.brandId }).finally(() => {
      if (this.brandId === null && this.brandList.length > 0) this.brandId = this.brandList[0].id
      this.fetchStores()
    })
  },
  methods: {
    ...mapActions('common', ['getStoreList']),
    fetchStores() {
      this.loading = true
      if (this.$route.query.brand) this.brandId = this.$route.query.brand
      this.getStoreList({ brand_id: this.brandId }).finally(() => {
        if (this.brandId === null && this.brandList.length > 0) this.brandId = this.brandList[0].id
        this.loading = false
      })
    },
    equalizeCardBody() {}
  }
}
</script>

<style lang="scss" scoped>
.salons-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  column-gap: 1.5rem;
  row-gap: 2rem;
}

.items-center {
  justify-items: center;
}
</style>
